import type { JSX } from 'react'

export const DolbyAtmosInlineIcon = (): JSX.Element => (
  <use href='#dolbyAtmosInlineIcon' height='100%' width='100%' />
)
